import React from 'react'
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import Browser from '../../components/Browser';
import Ticket01 from '../../assets/icons0/ticket-01.svg';
import CartButton from './local-cart/cart-button';

export const WarpEndpointsHeader = ({children, serviceById, mode}) => {
    return (
        <div className={classNames('padding-top-2rem position-sticky top-0 z-index-1', {'background-color-black': mode === 'dark', 'background-color-white': mode === 'light'})}>
            {children}
        </div>
    )
};

const EndpointsHeader = ({serviceById, localCartState, localCartStateDeferred, setCartVisibility, showCart}) => {
    return (
        <div className='padding-bottom-1rem border-bottom-1px-solid border-color-gray-700 display-flex justify-content-space-between align-items-center'>
            <div className='display-flex'>
                <Ticket01 className='display-block height-1dot5rem color-primary-500'/>
                <p className='margin-left-0dot75rem text-lg medium'><FormattedMessage defaultMessage='Tickets' /></p>
            </div>
            {showCart && <Browser fallback={<div className='display-none mw768-display-block min-width-11rem min-height-2dot75rem'></div>}>
                <CartButton {...{serviceById, localCartState, localCartStateDeferred, setCartVisibility}}/>
            </Browser>}
        </div>
    )
}

export default React.memo(EndpointsHeader);
